import {
  FunctionComponent,
  useEffect,
  useCallback,
  useState,
  useRef,
} from 'react'
import DarkCove from '@widgets/Video/DarkCove'
import { DarkCoveProps } from '@widgets/Video/types/darkcove'

import useInViewChange from '@hooks/useInViewChange'

export type BlickTVViewportBaseProps = Omit<DarkCoveProps, 'isInViewport'> & {
  popIn: () => void
  popOut: () => void
}

export const BlickTVViewport: FunctionComponent<BlickTVViewportBaseProps> = ({
  popIn,
  popOut,
  allowFloating,
  ...props
}) => {
  const [isInViewport, setIsInViewport] = useState(null)
  const previouslyWasInViewport = useRef<boolean>(false)

  useEffect(() => {
    if (allowFloating && isInViewport !== null) {
      if (isInViewport) {
        previouslyWasInViewport.current = true
        popIn()
      } else {
        if (previouslyWasInViewport.current) {
          popOut()
        }
      }
    }
  }, [isInViewport, popIn, popOut, allowFloating])

  const onInViewChangeHandler = useCallback((inView: any) => {
    // Workaround for full screen video issue in Safari / macOS (https://jira.ringieraxelspringer.ch/browse/BTV-109)
    // Root Cause: Waypoint fires useless `onEnter` and `onLeave` when video is in the fullscreen mode (Safari ONLY)
    // The following fix will prevent incorrect state of `isInViewport` when page is in full screen mode
    // @ts-ignore
    if (document.webkitCurrentFullScreenElement) {
      return
    }

    setIsInViewport(inView)
  }, [])

  const viewportRef = useInViewChange({
    onInViewChange: onInViewChangeHandler,
  })

  return (
    <div ref={viewportRef}>
      <DarkCove
        allowFloating={allowFloating}
        isInViewport={isInViewport}
        {...props}
      />
    </div>
  )
}

export default BlickTVViewport
